import axios from "../../config/interceptor";
import { getCurrentUtc } from "../../utils/utils";
import { PER_PAGE_SIZE } from "../../utils/constants";

export const postUseActivePackage = async (data) => {
  try {
    const response = await axios.post(`/lambda/v1/active-package`, data);

    return response;
  } catch (error) {
    return error;
  }
};

export const deleteActivePackage = async (id) => {
  try {
    const response = await axios.delete(
      `/lambda/v1/active-package/${id}`
    );

    return response;
  } catch (error) {
    return error;
  }
};

export const postUndoActivePackage = async (data) => {
  try {
    const response = await axios.post(`/lambda/v1/active-package/undo`, data);

    return response;
  } catch (error) {
    return error;
  }
};

export const getPatientPackages = async ({
  page = 1,
  size = PER_PAGE_SIZE,
  from,
  to,
  identity_number,
  name,
  phone_number,
  date_of_birth,
  busines_id,
}) => {
  try {
    const currentUtc = getCurrentUtc();

    let link = `/lambda/v1/patient-packages?`;
    link = link.concat("page=" + page);
    link = link.concat("&size=" + size);
    link = link.concat("&from=" + from);
    link = link.concat("&to=" + to);
    if (identity_number)
      link = link.concat("&identity_number=" + identity_number);
    if (name) link = link.concat("&name=" + name);
    if (phone_number) link = link.concat("&phone_number=" + phone_number);
    if (date_of_birth) link = link.concat("&date_of_birth=" + date_of_birth);
    if (busines_id) link = link.concat("&busines_id=" + busines_id);
    if (currentUtc) link = link.concat("&current_utc=" + currentUtc);

    const response = await axios.get(link);

    return response;
  } catch (error) {
    return error;
  }
};

export const getDetailPatientPackages = async (id) => {
  try {
    const currentUtc = getCurrentUtc();

    const response = await axios.get(
      `/lambda/v1/patient-packages/${id}?current_utc=${currentUtc}`
    );

    return response;
  } catch (error) {
    return error;
  }
};

export const getPatientPackagesHistory = async ({
  page = 1,
  size = PER_PAGE_SIZE,
  from,
  to,
  busines_id,
  patient_id,
  package_id,
  sort_by,
  sort_order,
}) => {
  try {
    const currentUtc = getCurrentUtc();

    let link = `/lambda/v1/patient-package-history?`;
    link = link.concat("page=" + page);
    link = link.concat("&size=" + size);
    if (from) link = link.concat("&from=" + from);
    if (to) link = link.concat("&to=" + from);
    if (patient_id) link = link.concat("&patient_id=" + patient_id);
    if (package_id) link = link.concat("&package_id=" + package_id);
    if (sort_by) link = link.concat("&sort_by=" + sort_by);
    if (sort_order) link = link.concat("&sort_order=" + sort_order);
    if (busines_id) link = link.concat("&busines_id=" + busines_id);
    if (currentUtc) link = link.concat("&current_utc=" + currentUtc);

    const response = await axios.get(link);

    return response;
  } catch (error) {
    return error;
  }
};
